import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let data = useDataValue({
    context: 'tab',
    path: 'selected.new_task_overlay.form',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'create_task',
      value: {
        ...data,
      },
    })
  }
}

export function isDisabled(board_id, stage_id, title, priority, action) {
  return (
    !board_id ||
    !stage_id ||
    !title ||
    !priority ||
    (action?.id && !action.document_template)
  )
}
